type Props = {
  children: React.ReactNode
}
function NavigationStackStyled({ children }: Props) {
  return (
    <div className="w-full flex flex-row justify-between text-base leading-[26px] lg:text-xl lg:leading-[30px]">
      {children}
    </div>
  )
}

export { NavigationStackStyled }
